import { ServiceProvider } from "@osjs/common";
import Swal from "sweetalert2";

export class AlertServiceProvider extends ServiceProvider {
  constructor(core, options = {}) {
    super(core, options || {});
    this.core = core;
  }

  providers() {
    return ["oxzion/alert"];
  }

  init() {
    this.core.instance("oxzion/alert", () => ({
      show: this.show,
      close: this.close,
      update: this.update,
    }));
  }

  buildAlertOptions(options = {}) {
    const {
      title,
      text,
      imageUrl,
      htmlContent,
      cancelButtonText,
      confirmButtonText,
      preConfirm,
      didOpen,
      icon,
      iconColor,
      input,
      inputPlaceholder,
      inputValidator,
      target,
      allowOutsideClick = true,
      showCloseButton = false,
    } = options;

    return {
      title,
      text,
      imageUrl,
      html: htmlContent ? `<div class="swal-html-content">${htmlContent}</div>` : undefined,
      customClass: "sweet-alert-container",
      showCancelButton: !!cancelButtonText,
      cancelButtonText,
      showConfirmButton: !!confirmButtonText,
      confirmButtonText,
      preConfirm,
      didOpen,
      target,
      input,
      inputPlaceholder,
      inputValidator,
      icon,
      iconColor,
      allowOutsideClick,
      allowEscapeKey: false,
      reverseButtons: true,
      showCloseButton,
      heightAuto: false, // Prevent SweetAlert2 from manipulating body height (fixes collapse with .osjs-root position:fixed)
    };
  }

  show = async (options) => {
    const result = await Swal.fire(this.buildAlertOptions(options));
    return options?.preConfirm ? result : result.isConfirmed;
  };

  close = async () => {
    return Swal.close();
  };

  update = (options) => {
    Swal.update(this.buildAlertOptions(options));
  };
}
